import { AuthoritiesGuard } from '@qima-labs/app/shared/guards/authorities/authorities.guard';
import { UnSaveGuard } from '@qima-labs/app/shared/guards/unsave.guard';
import { ERouters } from '@qima-labs/app/shared/models/enums/routers.enum';
import { Route } from '@angular/router';

export const TEST_ASSIGNMENT_ROUTES: Route[] = [
  {
    path: '',
    canActivate: [AuthoritiesGuard],
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./pages/test-assignment/test-assignment.component').then(m => m.TestAssignmentComponent),
  },
  {
    path: `${ERouters.CONFIRM_PARAMETERS}/:id/:orderId`,
    canActivate: [AuthoritiesGuard],
    canDeactivate: [UnSaveGuard],
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./pages/confirm-parameters/confirm-parameters.component').then(m => m.ConfirmParametersComponent),
  },
  {
    path: `${ERouters.EDIT_SPECIMEN}/:id/:orderId`,
    canActivate: [AuthoritiesGuard],
    canDeactivate: [UnSaveGuard],
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./pages/edit-specimen/edit-specimen.component').then(m => m.EditSpecimenComponent),
  },
  {
    path: `${ERouters.GENERATE_BREAKDOWN}/:id/:orderId`,
    canActivate: [AuthoritiesGuard],
    canDeactivate: [UnSaveGuard],
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    loadComponent: () => import('./pages/generate-breakdown-list/generate-breakdown-list.component').then(m => m.GenerateBreakdownListComponent),
  },
];
